import UbsRepository from '@/repositories/ubs-repository'
import axios from 'axios'
import notie from 'notie'
import { AxiosClient } from './utils/clients'
import AuthRepository from './repositories/auth-repository'
import { authActions } from './store/auth-reducer'
import AuthService from './services/auth-service'
import DashboardRepository from './repositories/dashboard-repository'
import DashboardService from './services/dashboard-service'
import DeviceRepository from './repositories/devices-repository'
import DevicesService from './services/devices-service'
import TransactionService from './services/transaction-service'
import TransactionRepository from './repositories/transaction-repository'
import WalletRepository from './repositories/wallet-repository'
import WalletService from './services/wallet-service'
import ReportRepository from './repositories/report-repository'
import ReportService from './services/report-service'
import { KILO_WATT_CONFIG, TarrifCalculatorService } from './services/tarrif-service'
import { store } from './store'
import { devicesStateActions } from './store/devices-reducer'
import { paySmallSmallActions } from './store/pay-small-small-reducer'
import PaySmallSmallService from './services/pay-small-small-service'
import { walletsActions } from './store/wallets-reducer'
import { transactionsActions } from './store/transactions-reducer'
import UbsService from './services/ubs-service'

const SERVER_CLIENT_TOKEN = process.env.NEXT_PUBLIC_SERVER_CLIENT_TOKEN

// client
const client = new AxiosClient(axios)

const serverSideClient = new AxiosClient(axios, {
    headers: {
        Authorization: SERVER_CLIENT_TOKEN,
    },
})

// Repositoris
const authRepository = new AuthRepository(client, serverSideClient)
const dashboardRepository = new DashboardRepository(client)
const deviceRepository = new DeviceRepository(client)
const transactionRepository = new TransactionRepository(client)
const walletRepository = new WalletRepository(client)
const reportRepository = new ReportRepository(client)
const ubsRepository = new UbsRepository(client)

// services
const authService = new AuthService(authRepository, store, authActions)
const dashboardService = new DashboardService(dashboardRepository, store)
const deviceService = new DevicesService(deviceRepository, store, devicesStateActions)
const transactionService = new TransactionService(
    transactionRepository,
    store,
    paySmallSmallActions,
    transactionsActions,
    deviceService,
)
const walletService = new WalletService(walletRepository, store, walletsActions)
const reportService = new ReportService(reportRepository, store)
const tarrifService = new TarrifCalculatorService(KILO_WATT_CONFIG)
const paySmallSmallService = new PaySmallSmallService(store, transactionService, paySmallSmallActions)
const ubsService = new UbsService(ubsRepository, store)

client.onLogout = () => {
    authService.logoutUser()
}

const alertError = (message: string) => {
    notie.alert({
        type: 'error',
        text: message,
    })
}

const DI = {
    authService,
    dashboardService,
    client,
    serverSideClient,
    deviceService,
    transactionService,
    walletService,
    reportService,
    tarrifService,
    alertError,
    paySmallSmallService,
    ubsService,
}

export default DI
